export default "__VITE_ASSET__BNHDE7KY__"